const initialize = (countryCode, partnerId, hasExtension) => {
  if (!partnerId) {
    console.error(`Braze wasn't initilized because no partner id was provided`)
    return
  }
  ;(function (a, p, P, b, y) {
    a.appboy = {}
    a.appboyQueue = []
    for (
      var s = 'initialize destroy getDeviceId toggleAppboyLogging setLogger openSession changeUser requestImmediateDataFlush requestFeedRefresh subscribeToFeedUpdates requestContentCardsRefresh subscribeToContentCardsUpdates logCardImpressions logCardClick logCardDismissal logFeedDisplayed logContentCardsDisplayed logInAppMessageImpression logInAppMessageClick logInAppMessageButtonClick logInAppMessageHtmlClick subscribeToNewInAppMessages subscribeToInAppMessage removeSubscription removeAllSubscriptions logCustomEvent logPurchase isPushSupported isPushBlocked isPushGranted isPushPermissionGranted registerAppboyPushMessages unregisterAppboyPushMessages trackLocation stopWebTracking resumeWebTracking wipeData ab ab.DeviceProperties ab.User ab.User.Genders ab.User.NotificationSubscriptionTypes ab.User.prototype.getUserId ab.User.prototype.setFirstName ab.User.prototype.setLastName ab.User.prototype.setEmail ab.User.prototype.setGender ab.User.prototype.setDateOfBirth ab.User.prototype.setCountry ab.User.prototype.setHomeCity ab.User.prototype.setLanguage ab.User.prototype.setEmailNotificationSubscriptionType ab.User.prototype.setPushNotificationSubscriptionType ab.User.prototype.setPhoneNumber ab.User.prototype.setAvatarImageUrl ab.User.prototype.setLastKnownLocation ab.User.prototype.setUserAttribute ab.User.prototype.setCustomUserAttribute ab.User.prototype.addToCustomAttributeArray ab.User.prototype.removeFromCustomAttributeArray ab.User.prototype.incrementCustomUserAttribute ab.User.prototype.addAlias ab.User.prototype.setCustomLocationAttribute ab.InAppMessage ab.InAppMessage.SlideFrom ab.InAppMessage.ClickAction ab.InAppMessage.DismissType ab.InAppMessage.OpenTarget ab.InAppMessage.ImageStyle ab.InAppMessage.TextAlignment ab.InAppMessage.Orientation ab.InAppMessage.CropType ab.InAppMessage.prototype.subscribeToClickedEvent ab.InAppMessage.prototype.subscribeToDismissedEvent ab.InAppMessage.prototype.removeSubscription ab.InAppMessage.prototype.removeAllSubscriptions ab.InAppMessage.prototype.closeMessage ab.InAppMessage.Button ab.InAppMessage.Button.prototype.subscribeToClickedEvent ab.InAppMessage.Button.prototype.removeSubscription ab.InAppMessage.Button.prototype.removeAllSubscriptions ab.SlideUpMessage ab.ModalMessage ab.FullScreenMessage ab.HtmlMessage ab.ControlMessage ab.Feed ab.Feed.prototype.getUnreadCardCount ab.ContentCards ab.ContentCards.prototype.getUnviewedCardCount ab.Card ab.Card.prototype.dismissCard ab.ClassicCard ab.CaptionedImage ab.Banner ab.ControlCard ab.WindowUtils display display.automaticallyShowNewInAppMessages display.showInAppMessage display.showFeed display.destroyFeed display.toggleFeed display.showContentCards display.hideContentCards display.toggleContentCards sharedLib'.split(
          ' ',
        ),
        i = 0;
      i < s.length;
      i++
    ) {
      for (
        var m = s[i], k = a.appboy, l = m.split('.'), j = 0;
        j < l.length - 1;
        j++
      )
        k = k[l[j]]
      /*eslint no-new-func: 0*/
      k[l[j]] = new Function(
        'return function ' +
          m.replace(/\./g, '_') +
          '(){window.appboyQueue.push(arguments); return true}',
      )()
    }
    window.appboy.getUser = function () {
      return new window.appboy.ab.User()
    }
    window.appboy.getCachedFeed = function () {
      return new window.appboy.ab.Feed()
    }
    window.appboy.getCachedContentCards = function () {
      return new window.appboy.ab.ContentCards()
    }
    ;(y = p.createElement(P)).type = 'text/javascript'
    y.src = 'https://js.appboycdn.com/web-sdk/2.4/appboy.min.js'
    y.async = 1
    ;(b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b)
  })(window, document, 'script')
  const enableLogging = process.env.NODE_ENV !== 'production'
  window.appboy.initialize(process.env.REACT_APP_BRAZE_API_KEY, {
    baseUrl: 'https://sdk.iad-03.braze.com/api/v3',
    enableLogging,
    // This lines set Braze SW to work with custom SW.
    // It avoids overriding firebase SW configuration.
    manageServiceWorkerExternally: true,
    disablePushTokenMaintenance: true,
    enableHtmlInAppMessages: true,
  })
  window.appboy.display.automaticallyShowNewInAppMessages()

  // This lines register Braze SW. However it is not compatible with Firebase yet, so it must be disabled until braze resolves the incompatibility.
  // if (
  //   window.appboy.isPushSupported() ||
  //   window.appboy.isPushPermissionGranted() ||
  //   !window.appboy.isPushBlocked()
  // ) {
  //   window.appboy.registerAppboyPushMessages();
  // }

  /*
   * If you have a unique identifier for this user (e.g. they are logged into your site) it's a good idea to call
   * changeUser here.
   * See https://js.appboycdn.com/web-sdk/latest/doc/module-appboy.html#.changeUser for more information.
   */

  window.appboy.changeUser(`${countryCode}_${partnerId}`)
  window.appboy.openSession()
  window.appboy.getUser().setCustomUserAttribute('PARTNER_COUNTRY', countryCode)
  window.appboy
    .getUser()
    .setCustomUserAttribute('HAS_CHROME_EXTENSION', hasExtension)
}

export default {
  initialize,
}
